module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cb-Db-Ec-Fb-Gd.0fa1ee50.png";